import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  container: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 14,
    textAlign: 'center',
    marginBottom: 20,
    marginTop: 10,
    fontFamily: 'Helvetica-Bold',
    textTransform: 'uppercase',
  },
  table: {
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
    width: '100%',
  },
  tableHeader: {
    backgroundColor: '#E4E4E4',
  },
  tableCol: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
    justifyContent: 'center',
  },
  colName: {
    width: '40%',
  },
  colEmail: {
    width: '35%',
  },
  colPhone: {
    width: '25%',
  },
  text: {
    fontSize: 9,
  },
  headerText: {
    fontSize: 9,
    fontFamily: 'Helvetica-Bold',
  },
});
